const fr = {
    demo: {
        title: `Anglais`,
        introduction: `Lorem Ipsum`,
    },
    docs: {
        hi: `Salut`,
        description: `Besoin d'aide ? \n Veuillez consulter notre documentation.`,
        documentation: `documentation`,
    },
    yes: `Oui`,
    no: `Non`,
    home: `Accueil`,
    dashboard: `Tableau de bord`,
    user: `Utilisateur`,
    account: `Compte`,
    general: `Général`,
    settings: `Paramètres`,
    username: `Nom d'utilisateur`,
    login: `Se connecter`,
    logout: `Se déconnecter`,
    emailAddress: `Adresse e-mail`,
    password: `Mot de passe`,
    newPassword: `Nouveau mot de passe`,
    oldPassword: `Ancien mot de passe`,
    confirmNewPassword: `Confirmer le nouveau mot de passe`,
    updatePassword: `Mettre à jour le mot de passe`,
    formErrorValidEmail: `L'e-mail doit être une adresse e-mail valide`,
    formErrorEmailRequired: `L'e-mail est requis`,
    formErrorPasswordRequired: `Le mot de passe est requis`,
    formErrorOldPasswordRequired: `L'ancien mot de passe est requis`,
    formErrorPasswordLength: `Le mot de passe doit comporter au moins 6 caractères`,
    formErrorConfirmPasswordRequired: `La confirmation du mot de passe est requise`,
    formErrorPasswordsMatch: `Les mots de passe doivent correspondre`,
    formForgotPasswordLink: `Mot de passe oublié ?`,
    snackBarChangePasswordSuccess: `Changement de mot de passe réussi !`,
    snackBarUpdateSuccess: `Mise à jour réussie !`,
    active: `Actif`,
    inactive: `Inactif`,
    on: `Activé`,
    off: `Désactivé`,
    billing: `Facturation`,
    description: `Description`,
    amount: `Montant`,
    status: `Statut`,
    changePassword: `Changer le mot de passe`,
    changeSettings: `Changer les paramètres`,
    setup: `Configuration`,
    free: `Gratuit`,
    invoices: `Factures`,
    cancelSubscriptionButton: `Annuler l'abonnement`,
    date: 'Date',
    download: 'Télécharger',
    print: 'Imprimer',
    close: 'Fermer',
    view: 'Voir',
    DataOwl: `Data Owl`,
    DataOwlTip: `Data Owl analyse les sources web cachées pour détecter si votre adresse e-mail apparaît dans des fuites de données, vous aidant à rester en sécurité grâce à des alertes en temps voulu.`,
    warningBanner: {
        text: 'Vous n’avez pas de compte actif. Pour activer votre compte, renouvelez-le en cliquant sur le bouton.',
        ctaButton: 'Renouveler',
        caption: 'Légende'
    },
    loginPage: {
        title: `Se connecter`,
        formTitle: `Nouveau sur Anomica ? Créer un compte`,
        formTitleLink: `ici`,
        formForgotPasswordLink: `Mot de passe oublié ?`
    },
    resetPasswordPage: {
        title: `Réinitialiser le mot de passe`,
        formTitle: `Mot de passe oublié ?`,
        formSubTitle: ` Veuillez entrer l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe par e-mail.`,
        formTitleLink: `Retour à la connexion`,
        formButton: `Envoyer la demande`,
    },
    newPasswordPage: {
        title: `Réinitialiser le mot de passe`,
        formTitle: `Demande envoyée avec succès !`,
        formSubTitle: `Nous avons envoyé un e-mail avec un lien de confirmation.`,
        formSubTitle2: `Veuillez visiter le lien pour vérifier votre e-mail.`,
        formTitleLink: `Retour à la connexion`,
        formButton: `Envoyer la demande`,
    },
    accountPage: {
        title: `Compte`,
        accountStatus: `Statut du compte`,
        accountType: `Type de compte`,
        renewAccount: `Renouveler le compte`,
        endDate: `Date de fin`,
        subRemaining: `Abonnement restant :`,
        autoRenew: `Le renouvellement automatique est`,
        vpnCredentials: `Identifiants VPN :`,
        setupVpn: `Configurer VPN`,
        nextBillingDate: `Prochaine date de facturation`,
        endOfFreeTerm: `Fin de la période gratuite`,
        cancelSubscription: `Annuler l'abonnement`,
        activationCode: `Code d'activation`,
        newsNotifications: `E-mails de nouvelles et notifications`,
        darkWebMonitoring: `Bouclier Dark Web`,
        setupMonitoring: `Configurer la surveillance`,
        recurringSubscription: `Abonnement récurrent`,
        getSubscription: 'Obtenir un abonnement',
        nextBillingDateWarning: 'La date exacte de facturation peut varier et dépend de la méthode de paiement.',
        tabs: {
            general: `Général`,
            settings: `Paramètres`,
            changePassword: `Changer le mot de passe`
        },
    },
    settingsPage: {
        title: `Paramètres`,
        formTitle: `NOTIFICATIONS & NEWSLETTERS`,
        recurringPayment: ` Paiement récurrent`,
        yourSubscription: `Votre abonnement`,
        per: `Par`,
        curSubs: `L'abonnement actuel continuera jusqu'à`,
        warn: `Votre compte ne sera plus prolongé mensuellement.`,
        submitButton: `Enregistrer les modifications`,
        settingsOption1: `Nouvelles et annonces`
    },
    setupVpnPage: {
        title: `Configurer VPN`,
        header: `Télécharger VPN Pays-Bas pour {{os}}`,
        coverH1: `Téléchargez l'application en un clic`,
        coverH2: `Vous n'avez qu'à télécharger, tout est rempli pour vous`,
        coverH3: `Également disponible pour`,
        coverButtonText: 'Télécharger pour ',
        setupBadge: `CONFIGURER ANOMICA`,
        preferManual: `Vous préférez installer manuellement ? Consultez les étapes ci-dessous.`,
        installManuallyLink: `Installer manuellement`,
        footerText: `Si vous avez encore des questions, contactez-nous à`,
        tabH1: `Le code d'activation est déjà rempli pour vous et vous n'avez qu'à télécharger VPN Pays-Bas.`,
        tabH2: `Préférez l'installer manuellement ?`,
        step1: ` Télécharger`,
        step1Caption: `Le code d'activation est déjà rempli pour vous et vous n'avez qu'à télécharger VPN Pays-Bas. Préférez l'installer manuellement ?`,
        step2: ` Copier`,
        step2Caption: `Copiez le code d'activation et utilisez-le lors de la configuration du logiciel.`,
        step3: ` Coller`,
        step3Caption: `Collez le code d'activation copié dans le logiciel pour compléter l'installation de VPN Pays-Bas.`,
        manual: {
          disabledTooltip: `Disponible uniquement pour les utilisateurs autorisés avec un abonnement actif.`,
          authRequired: `Veuillez vous connecter pour continuer.`,
          step1: `Choisir un serveur`,
          step1Caption: `Sélectionnez un pays et un serveur auquel vous connecter.`,
          country: `Pays`,
          server: `Serveur`,
          protocol: `Protocole`,
          step2: `Télécharger le fichier de configuration`,
          step2Caption: `Téléchargez le fichier de configuration .ovpn pour le serveur sélectionné.`,
          downloadButton: `Télécharger .ovpn`,
          step3: `Connecter`,
          step3Caption: `Ouvrez le client OpenVPN, importez le fichier téléchargé et connectez-vous. Utilisez le Login VPN et le Mot de passe VPN indiqués ci-dessous.`,
        },
    },
    promoPage: {

        tabH1: `Félicitations et bienvenue !. Votre limite de trafic a été mise à niveau. Profitez de 5 Go d'utilisation mensuelle. `,
        tabH2: `Vous n'avez qu'à télécharger, tout est rempli pour vous`,
    },
    cancelSubscription: {
        h1: `Si vous souhaitez annuler votre abonnement, `,
        h1br:`vous pouvez le faire facilement ci-dessous.`,
        sub1: `Nous sommes ravis de vous avoir eu comme membre. Vous êtes toujours le bienvenu pour revenir.`,
        sub1br: `Vous pouvez compléter votre annulation ci-dessous.`,
        cardTitle: `Annuler l'abonnement`,
        cardText: `Êtes-vous sûr de vouloir renoncer à votre confidentialité en ligne ? Utilisez alors le bouton ci-dessous pour compléter l'annulation de votre abonnement.`,
        cancelButton: `Compléter l'annulation`,
        backButton: `Retour au site web`,
        cardCaption: `L'annulation prendra effet à la fin de votre période de facturation actuelle`,
        cardCaptionBr: `le`,
        h2: `Pourquoi rester avec VPN Pays-Bas ?`,
        p1: `100% Confidentialité`,
        p1c: `Avec Anomica, toutes les préoccupations concernant votre confidentialité en ligne appartiennent au passé. Personne ne peut voir vos données et vous pouvez vous déplacer librement en ligne.`,
        p2: `100% Sécurité`,
        p2c: `Parce qu'une VPN chiffre votre connexion, il n'est plus possible pour les hackers de s'introduire. Cela les empêchera de s'enfuir avec vos données.`,
        p3: `100% Liberté`,
        p3c: `Avec Anomica, vous pouvez contourner les blocs géographiques et prétendre être dans un autre pays, afin de profiter de 100% de liberté en ligne.`,
        p4: `100% Streaming`,
        p4c: `Avec Anomica, vous avez accès à chaque service de streaming (étranger). Avantage supplémentaire : Nos connexions ultra-rapides sont parfaites pour le streaming !`,
        p5: `100% Téléchargement`,
        p5c: `Avec les serveurs ultra-rapides et les protocoles modernes de VPN Pays-Bas, vous pouvez télécharger et streamer sans effort partout dans le monde.`,
        exButton: `Rester en sécurité en ligne`,
        h1Canceled: `Vous avez annulé votre abonnement avec succès.`,
        h1CanceledFree: `Vous avez annulé votre abonnement avec succès.`,
        sub1Canceled: `Merci d'avoir été membre, revenez quand vous voulez !`,
        sure: `Êtes-vous sûr ?`,
        happy: `Nous serons ravis de vous revoir à tout moment.`
    },
    verifyEmailPage: {
        title: ``,
        checkYourEmail: `Veuillez vérifier votre e-mail !`,
        inProgress: `Vérification en cours...`,
        bottomText: `Toutes les informations concernant votre abonnement et l'application se trouvent dans votre boîte de réception.`,
        success: `E-mail vérifié !`,
        alreadyVerified: 'E-mail déjà vérifié !',
        button: `Voir votre compte`,
        p1: `Vous avez choisi VPN Pays-Bas`,
        p2: `Vous vous êtes inscrit avec succès`,
        p3: `Votre adresse e-mail a été vérifiée avec succès`,
        p4: `Votre abonnement VPN Pays-Bas a été activé.`,
    },
    billingPage: {

        paymentFor: `Paiement pour`,
        invoiceNumber: `ID de facture`,
    },
    monitoringPage: {
      title: `Data Owl`,
      setUpMonitoring: `Configurer la surveillance`,
      featureActivatedAlert: `Data Owl est maintenant activé`,
      featureNotActivatedAlert: `Data Owl n'est actuellement pas activé`,
      notifyToggleLabel: `Me notifier lorsqu'une nouvelle fuite de données est détectée`,
      consentDisclaimer: `En activant cette fonctionnalité, vous acceptez que nous partagions votre adresse e-mail avec des services d'analyse sécurisés pour vérifier les fuites de données. Vous recevrez une notification par e-mail lorsque de nouvelles fuites seront découvertes.`,
      breachesDetectedTitle: `Fuites de données détectées`,
      breachesFoundWarning: `Oh non ! Nous avons trouvé <0>{{number}} {{breachWord}}</0>, y compris des mots de passe divulgués. Lisez <1>notre article</1> pour en savoir plus sur la façon de vous protéger contre les fuites futures.`,
      breach_one: `fuite de données`,
      breach_other: `fuites de données`,
      btnUpdating: `Mise à jour...`,
      btnSaveAndScan: `Enregistrer les modifications et scanner maintenant`,
      btnSave: `Enregistrer les modifications`,
      btnAddedToQueue: `Ajouté à la file d'attente...`,
      btnDataRetrieved: `Données récupérées`,
      compromisedData: `Données divulguées :`,
      dataOwl: {
        faq: {
          what_does_it_do: {
            heading: `Que fait cette fonctionnalité ?`,
            detail: `L'outil Data Owl scanne en continu le Dark Web et les bases de données fuites connues à la recherche des adresses e-mail que vous choisissez de surveiller. Si vos données sont trouvées dans une fuite, vous recevrez une alerte instantanée avec des détails sur la source et la date de la fuite, les informations exposées et d'autres informations pertinentes. Vous obtiendrez également des guides clairs sur la façon de sécuriser vos comptes.`,
          },
          how_does_it_work: {
            heading: `Comment cet outil m'aide-t-il à me protéger ?`,
            detail: `Les fuites de données et les violations de sécurité se produisent chaque jour et représentent une menace sérieuse pour votre sécurité en ligne. Une fois vos données divulguées, elles peuvent être immédiatement utilisées pour toutes sortes de cyberattaques – du phishing et des escroqueries en ligne à la prise de contrôle de comptes et à la fraude financière. Data Owl d'Anomica vous aide à garder une longueur d'avance en vous notifiant dès qu'une fuite se produit, en fournissant des rapports détaillés et en offrant des conseils professionnels pour gérer chaque situation.`,
          },
          does_it_solve_anything: {
            heading: `Cette fonctionnalité est-elle gratuite ?`,
            detail: `L'outil Data Owl est inclus dans chaque abonnement Anomica sans frais supplémentaires. Il offre une surveillance 24/7, un suivi illimité des e-mails, des rapports de fuites détaillés et des conseils personnalisés pour vous aider à répondre à tout incident.`,
          },
        },
      },
      dataClasses: {
        "Email addresses": `Adresses e-mail`,
        Passwords: `Mots de passe`,
        Usernames: `Noms d'utilisateur`,
        "IP addresses": `Adresses IP`,
        "Physical addresses": `Adresses physiques`,
        "Phone numbers": `Numéros de téléphone`,
        Names: `Noms`,
        "Job titles": `Titres de poste`,
        "Dates of birth": `Dates de naissance`,
        "Financial data": `Données financières`,
        "Credit cards": `Cartes de crédit`,
        "Bank account numbers": `Numéros de compte bancaire`,
        "Social security numbers": `Numéros de sécurité sociale`,
        "Historical passwords": `Anciens mots de passe`,
      },
    },
    invoiceDetailsPage: {
        title: `Facture`,
        email: 'E-mail',
        customerNumber: 'Numéro de client',
        invoiceFrom: 'Facture de',
        invoiceTo: 'Facture à',
        invoiceDate: 'Date de facture',
        invoicePaymentMethod: 'Méthode de paiement',
        invoiceDescription: 'Description',
        invoiceProductQty: 'Qté',
        invoiceProductPrice: 'Prix',
        invoiceTotal: 'Total',
        invoiceSubtotal: 'Sous-total',
        invoiceVat: 'Taxes (TVA)',
        supportDescription: 'Avez-vous une question ?',
        status: {
            open: 'Ouvert',
            paid: 'payé',
            canceled: 'annulé',
            pending: 'en attente',
            chargeback: 'remboursement',
            expired: 'expiré',
            failed: 'échoué',
            settled: 'réglé',
            partially_refunded: 'partiellement remboursé',
            refunded: 'remboursé',
            authorized: 'autorisé',
            internal_error: 'erreur interne',
        }
    },
    maintenancePage: {

        h1: `Nous effectuons une maintenance.`,
        h2: `De retour bientôt !`,
    },
    page404: {
        h1: `Oups… la page que vous cherchez n'existe pas.`,
        p: `Perdu lors de votre recherche du fournisseur Anomica ? Pas de souci, nous vous y amenons !`,
        btn: `Amenez-moi au meilleur VPN !`,
    }
};

export default fr;
